import React from 'react';
import ReactDOM from 'react-dom';
import './styles/general.css';
import App from './composants/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);